import { IonButton } from '@ionic/react';
import React from 'react';
import styled from 'styled-components';
import { t } from 'ttag';

import { ReactComponent as OnsiteImage } from '@assets/login-landscape.svg';
import { ReactComponent as LandscapeImageLeadCapture } from '@assets/login-lead-capture-landscape-old.svg';
import Product from '@custom-types/Product';
import RoutePath from '@custom-types/RoutePath';
import useLogin, { LoginType } from '@hooks/useLogin';
import { generateRoute, getProduct } from '@services/navigation-service';

import Layout from './Layout';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex: 1;
  width: 100%;
  padding: 0 16px;
  margin-bottom: 64px;
`;

const LandscapeImageOnsite = styled(OnsiteImage)`
  height: 35vh;
`;

const Button = styled(IonButton)`
  margin-top: 16px;
`;

const Home = () => {
  useLogin(LoginType.CheckStatus);
  const product = getProduct();

  return (
    <Layout>
      <Container>
        {product !== Product.LeadCapture && <LandscapeImageOnsite />}
        {product === Product.LeadCapture && <LandscapeImageLeadCapture />}
        <div>
          {product !== Product.LeadCapture && (
            <Button
              role="button"
              expand="block"
              routerLink={generateRoute(RoutePath.LoginWithPassword, { email: undefined })}
            >{t`Log In With Password`}</Button>
          )}
          <Button
            role="button"
            expand="block"
            routerLink={generateRoute(RoutePath.LoginWithCode, { email: undefined })}
          >{t`Log In with Access code`}</Button>
        </div>
      </Container>
    </Layout>
  );
};

export default Home;
